

export const reportType = [
    { key: '1', value: 'account', text: 'Generate a spreadsheet containing payments made towards individual accounts.' }
    , { key: '2', value: 'client', text: 'Generate a spreadsheet containing a summary of payments made to selected clients.' }
];

export const relationShip = [
    { key: '1', value: 'Spouse', text: 'Spouse' }
    , { key: '2', value: 'Partner', text: 'Partner' }
    , { key: '3', value: 'Ex-Spouse', text: 'Ex-Spouse' }
    , { key: '4', value: 'Mother', text: 'Mother' }
    , { key: '5', value: 'Father', text: 'Father' }
    , { key: '6', value: 'Brother', text: 'Brother' }
    , { key: '7', value: 'Other', text: 'Other' }
];

export const adjustmentStatus = [
    { key: '1', value: '', text: 'All' }
    , { key: '2', value: 'Adjustment Pending', text: 'Adjustment Pending' }
    , { key: '3', value: 'Adjustment Rejected', text: 'Adjustment Rejected' }
    , { key: '4', value: 'Adjustment Reversed', text: 'Adjustment Reversed' }
    , { key: '5', value: 'Adjustment Approved', text: 'Adjustment Approved' }
];

export const paymentStatus = [
    { key: '0', value: '', text: 'All' }
    , { key: '2', value: 'Payment Pending', text: 'Payment Pending' }
    , { key: '3', value: 'Payment Rejected', text: 'Payment Rejected' }
    , { key: '4', value: 'Payment Reversed', text: 'Payment Reversed' }
    , { key: '5', value: 'Payment Approved', text: 'Payment Approved' }
];


export const adjustmentType = [
    { key: '0', value: '', text: '-- Select --' }
    , { key: '2', value: 'Insurance', text: 'Insurance' }
    , { key: '3', value: 'Financial Assistance', text: 'Financial Assistance' }
    , { key: '4', value: 'Courtesy Adjustment', text: 'Courtesy Adjustment' }
    , { key: '5', value: 'Management Review', text: 'Management Review' }
    , { key: '6', value: 'Workman\'s Compensation', text: 'Workman\'s Compensation' }
    , { key: '7', value: 'Offset Tax\'s', text: "Offset Tax's" }
    , { key: '8', value: 'Balance Corrections', text: "Balance Corrections" }
    , { key: '9', value: 'Other', text: 'Other' }
];


export const paymentType = [
    { key: '0', value: '', text: '-- Select --' }
    , { key: '2', value: 'Insurance Payment', text: 'Insurance Payment' }
    , { key: '3', value: 'Medicaid/State Insurance', text: 'Medicaid/State Insurance' }
    , { key: '4', value: 'Walk-in Payment', text: 'Walk-in Payment' }
    , { key: '5', value: 'Worker\'s Compensation/SAIF', text: 'Worker\'s Compensation/SAIF' }
    , { key: '6', value: 'Consumer/Patient Payment', text: 'Consumer/Patient Payment' }
    , { key: '7', value: 'Other', text: 'Other' }
];

export const holds = [
    { key: '1', text: '15', value: '15' },
    { key: '2', text: '30', value: '30' },
    { key: '3', text: '45', value: '45' },
    { key: '4', text: '60', value: '60' },
    { key: '5', text: '90', value: '90' },
    { key: '6', text: '120', value: '120' },
];

export const holdReason = [
    { key: '1', text: 'Bridge Application Sent', value: 'Bridge Application Sent', },
    { key: '2', text: 'Bridge Application Received', value: 'Bridge Application Received' },
    { key: '3', text: 'Insurance Billing', value: 'Insurance Billing' },
    { key: '4', text: 'Charge Dispute', value: 'Charge Dispute' },
    { key: '5', text: 'Care Concern', value: 'Care Concern' },
    { key: '6', text: 'Payment Plan Pending', value: 'Payment Plan Pending' },
    { key: '7', text: 'Management Review', value: 'Management Review' },
    { key: '8', text: 'Other', value: 'Other' },
    { key: '9', text: 'Investigating Tax Liability', value: 'Investigating Tax Liability' },
    { key: '10', text: 'Investigating Consumers Dispute', value: 'Investigating Consumers Dispute' },
    { key: '11', text: 'Investigating Identity Theft', value: 'Investigating Identity Theft' }
];

export const cancelReason = [{ key: 1, value: "Back Online", text: "Back Online" },
{ key: 2, value: "Cancel Consumer is Deceased", text: "Cancel Consumer is Deceased" },
{ key: 3, value: "Cancel Consumer to Perform Community Service", text: "Cancel Consumer to Perform Community Service" },
{ key: 4, value: "Cancel due to Fraud or Identity Theft", text: "Cancel due to Fraud or Identity Theft" },
{ key: 5, value: "Cancelled per guidelines", text: "Cancelled per guidelines" },
{ key: 6, value: "Consumer paid prior to collections", text: "Consumer paid prior to collections" },
{ key: 7, value: "Duplicate account sent", text: "Duplicate account sent" },
{ key: 8, value: "Financial Assistance through Charity ", text: "Financial Assistance through Charity " },
{ key: 9, value: "Judges Orders", text: "Judges Orders" },
{ key: 10, value: "Management review, errors found on file at client office", text: "Management review, errors found on file at client office" },
{ key: 11, value: "Not enough contact due to policy", text: "Not enough contact due to policy" },
{ key: 12, value: "Recent contact, consumer made arrangements", text: "Recent contact, consumer made arrangements" },
{ key: 13, value: "Reprocessing-Rebilling for possible insurance", text: "Reprocessing-Rebilling for possible insurance" },
{ key: 14, value: "Return mail policy", text: "Return mail policy" },
{ key: 15, value: "Sent in Error, Incorrect Agency", text: "Sent in Error, Incorrect Agency" }];


export const documentTypes = [
    { key: '0', text: 'Authorization', value: 'H' },
    { key: '1', text: 'Assignment', value: 'A' },
    { key: '2', text: 'Contracts', value: 'C' },
    { key: '3', text: 'Statement', value: 'S' },
    { key: '4', text: 'Others', value: 'O' },
    { key: '5', text: 'General Account Comment', value: 'G' },
    { key: '6', text: 'Resolve Account With Comment', value: 'R' }
];

export const addressType = [
    { key: '1', text: 'Good Address', value: '1' },
    { key: '2', text: 'Bad Address', value: '2' }
];

export const balanceType = [
    { key: '1', text: 'Greater Than', value: 'greaterThan' },
    { key: '2', text: 'Less Than', value: 'lessThan' },
    { key: '3', text: 'Equal To', value: 'equalTo' },
    { key: '4', text: 'Greater Than or Equal To', value: 'greaterThanOrEqualTo' },
    { key: '5', text: 'Less Than or Equal To', value: 'lessThanOrEqualTo' },
    { key: '6', text: 'Not Equal To', value: 'notEqualTo' }
];

export const dosCondition = [
    { key: '1', text: 'Equals', value: 'equals' },
    { key: '2', text: 'Before', value: 'before' },
    { key: '3', text: 'After', value: 'after' },
    { key: '4', text: 'Between', value: 'between' }
];

export const timeFrame = [
    { key: '1', text: 'Yesterday', value: 'yesterday' },
    { key: '2', text: 'Last Week', value: 'lastWeek' },
    { key: '3', text: 'Last Month', value: 'lastMonth' },
    { key: '4', text: 'Last Three Month', value: 'lastThreeMonth' },
    { key: '5', text: 'Last Quarter', value: 'lastQuarter' },
    { key: '6', text: 'Last Twelve Month', value: 'lastTwelveMonth' },
    { key: '7', text: 'Last Year', value: 'lastyear' }
];

export const cancelReportColumns = [
    { key: '1', value: 'ACCOUNT INFORMATION', text: 'ACCOUNT INFORMATION', disabled: true },
    { key: '2', value: 'accountNumber', text: 'Account Number' },
    { key: '3', value: 'accumlatedInterest', text: 'Accumulated Interest' },
    { key: '4', value: 'amountReferred', text: 'Amount Referred' },
    { key: '5', value: 'attorneyFee', text: 'Attorney Fees' },
    { key: '6', value: 'cancelledDate', text: 'Cancellation / Hold Date' },
    { key: '7', value: 'clientAccountNumber', text: 'Client Account Number' },
    { key: '8', value: 'clientCollectionFee', text: 'Client Collection Fee' },
    { key: '9', value: 'clientName', text: 'Client Name' },
    { key: '10', value: 'clientNumber', text: 'Client Number' },
    { key: '11', value: 'clientReferredFee', text: 'Client Referred Fee' },
    { key: '12', value: 'clientReferredInterest', text: 'Client Referred Interest' },
    { key: '13', value: 'courtCosts', text: 'Court Costs' },
    // { key: '14', value: 'facility', text: 'Facility' },
    { key: '15', value: 'lastPayment', text: 'Last Payment' },
    { key: '16', value: 'principal', text: 'Principal' },
    { key: '17', value: 'referredDate', text: 'Referral Date' },
    { key: '18', value: 'serviceDate', text: 'Service Date' },
    { key: '19', value: 'status', text: 'Status' },
    { key: '20', value: 'totalDue', text: 'Total Due' },
    { key: '21', value: 'DEMOGRAPHICS', text: 'DEMOGRAPHICS', disabled: true },
    { key: '22', value: 'badAddress', text: 'Bad Address' },
    { key: '23', value: 'firstName', text: 'First Name' },
    { key: '24', value: 'lastName', text: 'Last Name' },
    { key: '25', value: 'phone', text: 'Phone' },
    { key: '26', value: 'street1', text: 'Street 1' },
    { key: '27', value: 'street2', text: 'Street 2' },
    { key: '28', value: 'city', text: 'City' },
    { key: '29', value: 'stateZip', text: 'State / Zip' },
    { key: '30', value: 'BANKRUPTCY', text: 'DEMOGRAPHICS', disabled: true },
    { key: '31', value: 'bankruptyStatus', text: 'Bankruptcy Status' },
    { key: '32', value: 'chapterNumber', text: 'Chapter Number' },
    { key: '33', value: 'closeDate', text: 'Close Date' },
    { key: '34', value: 'dismissed', text: 'Dismissed' },
    { key: '35', value: 'fillingDate', text: 'Filing Date' },
    { key: '36', value: 'currencyCode', text: 'Currency Code' },
];

export const yesNo = [
    { key: '1', text: 'Yes', value: 'Y' },
    { key: '2', text: 'No', value: 'N' }
];

export const state = [
    { key: '1', value: 'AL', text: 'Alabama' },
    { key: '2', value: 'AK', text: 'Alaska' },
    { key: '3', value: 'AZ', text: 'Arizona' },
    { key: '4', value: 'AR', text: 'Arkansas' },
    { key: '5', value: 'CA', text: 'California' },
    { key: '6', value: 'CO', text: 'Colorado' },
    { key: '7', value: 'CT', text: 'Connecticut' },
    { key: '8', value: 'DE', text: 'Delaware' },
    { key: '9', value: 'DC', text: 'District Of Columbia' },
    { key: '10', value: 'FL', text: 'Florida' },
    { key: '11', value: 'GA', text: 'Georgia' },
    { key: '12', value: 'HI', text: 'Hawaii' },
    { key: '13', value: 'ID', text: 'Idaho' },
    { key: '14', value: 'IL', text: 'Illinois' },
    { key: '15', value: 'IN', text: 'Indiana' },
    { key: '16', value: 'IA', text: 'Iowa' },
    { key: '17', value: 'KS', text: 'Kansas' },
    { key: '18', value: 'KY', text: 'Kentucky' },
    { key: '19', value: 'LA', text: 'Louisiana' },
    { key: '20', value: 'ME', text: 'Maine' },
    { key: '21', value: 'MD', text: 'Maryland' },
    { key: '22', value: 'MA', text: 'Massachusetts' },
    { key: '23', value: 'MI', text: 'Michigan' },
    { key: '24', value: 'MN', text: 'Minnesota' },
    { key: '25', value: 'MS', text: 'Mississippi' },
    { key: '26', value: 'MO', text: 'Missouri' },
    { key: '27', value: 'MT', text: 'Montana' },
    { key: '28', value: 'NE', text: 'Nebraska' },
    { key: '29', value: 'NV', text: 'Nevada' },
    { key: '30', value: 'NH', text: 'New Hampshire' },
    { key: '31', value: 'NJ', text: 'New Jersey' },
    { key: '32', value: 'NM', text: 'New Mexico' },
    { key: '33', value: 'NY', text: 'New York' },
    { key: '34', value: 'NC', text: 'North Carolina' },
    { key: '35', value: 'ND', text: 'North Dakota' },
    { key: '36', value: 'OH', text: 'Ohio' },
    { key: '37', value: 'OK', text: 'Oklahoma' },
    { key: '38', value: 'OR', text: 'Oregon' },
    { key: '39', value: 'PA', text: 'Pennsylvania' },
    { key: '40', value: 'RI', text: 'Rhode Island' },
    { key: '41', value: 'SC', text: 'South Carolina' },
    { key: '42', value: 'SD', text: 'South Dakota' },
    { key: '43', value: 'TN', text: 'Tennessee' },
    { key: '44', value: 'TX', text: 'Texas' },
    { key: '45', value: 'UT', text: 'Utah' },
    { key: '46', value: 'VT', text: 'Vermont' },
    { key: '47', value: 'VA', text: 'Virginia' },
    { key: '48', value: 'WA', text: 'Washington' },
    { key: '49', value: 'WV', text: 'West Virginia' },
    { key: '50', value: 'WI', text: 'Wisconsin' },
    { key: '51', value: 'WY', text: 'Wyoming' }
];

export const holdDays = [
    { key: '1', text: '15', value: '15' },
    { key: '2', text: '30', value: '30' },
    { key: '3', text: '45', value: '45' },
    { key: '4', text: '60', value: '60' },
    { key: '5', text: '75', value: '75' },
    { key: '6', text: '90', value: '90' },
];

export const typeList = [
    { key: "inbox", "icon": "mail", value: "Inbox", "count": 0 },
    { key: "send", "icon": "send", value: "Sent", "count": 0 },
    { key: "important", "icon": "warning", value: "Important", "count": 0 },
    { key: "saved", "icon": "save", value: "Saved", "count": 0 },
    { key: "draft", "icon": "firstdraft", value: "Drafts", "count": 0 },
    { key: "trash", "icon": "trash", value: "Trash", "count": 0 }
]


export const folderList = [
    { key: "inbox", "icon": "mail", text: "Inbox", value: "inbox" },
    { key: "important", "icon": "warning", text: "Important", value: "important" },
    { key: "saved", "icon": "save", text: "Saved", value: "saved" },
    { key: "trash", "icon": "trash", text: "Trash", value: "trash" }
]

export const getBrowserLocaleLanguage = () => {
    const language = window.navigator.userLanguage || window.navigator.language;
    return language.length ? language : 'en-US'
}

export const fileTypeList = [
    { key: '1', text: '.txt', value: '.txt' },
    { key: '2', text: '.xls', value: '.xls' },
    { key: '3', text: '.xlsx', value: '.xlsx' },
    { key: '4', text: '.csv', value: '.csv' },
    { key: '5', text: 'Other', value: 'Other' }
];


// WEBPACK FOOTER //
// ./src/app/utils/defaults.js